"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _excluded = ["className", "wrapperClassName", "fluid", "fullyResponsive", "use16Cols", "wrapperRef", "wrapperProps"];
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CSS_BLOCK = 'sapcnqr-layout-grid';

/**
 * The **LayoutGrid** component is used in conjunction with the **Row**, **Col**
 * and **Clearfix** components to define responsive page layouts.
 */

var LayoutGrid = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
    wrapperClassName = props.wrapperClassName,
    fluid = props.fluid,
    fullyResponsive = props.fullyResponsive,
    use16Cols = props.use16Cols,
    wrapperRef = props.wrapperRef,
    wrapperProps = props.wrapperProps,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _classnames2.default)(className, (0, _defineProperty2.default)({
    container: !fluid && !use16Cols,
    'container-fluid': fluid && !use16Cols,
    'cnqr-grid-responsive-partial': !fullyResponsive && !use16Cols
  }, "".concat(CSS_BLOCK), use16Cols));
  var wrapperClasses = (0, _classnames2.default)(wrapperClassName, "".concat(CSS_BLOCK, "__wrapper"), wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className);

  // eslint-disable-next-line consistent-return
  var addChildProps = (0, _react.useCallback)(function (child) {
    if (child.displayName === 'Col' || child.displayName === 'Clearfix' || child.displayName === 'Row') {
      return {
        use16Cols: use16Cols
      };
    }
  });
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, wrapperProps, {
    className: wrapperClasses,
    ref: wrapperRef
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: ref
  }))));
});
LayoutGrid.displayName = 'LayoutGrid';
LayoutGrid.propTypes = {
  /** Custom classes to add to the grid layout container’s `<div>` tag. */
  className: _propTypes.default.string,
  /** Custom classes to add to the grid layout wrapper's `<div>` tag. */
  wrapperClassName: _propTypes.default.string,
  /** When true, turn a fixed-width grid layout into a full-width layout. */
  fluid: _propTypes.default.bool,
  /** When true, the grid container will be responsive for all viewport sizes.
   * The default for SAP Concur’s applications is to not be responsive below the
   * medium viewport size. */
  fullyResponsive: _propTypes.default.bool,
  /** When true, the grid will be based of 16 columns instead of the default 12. It
   * will be responsive for all viewport sizes regardless of the value of the
   * `fullyResponsive` prop.
   */
  use16Cols: _propTypes.default.bool,
  /** Additional props to spread to the grid layout wrapper's `<div>` tag. */
  wrapperProps: _propTypes.default.any,
  /** Ref for the grid layout wrapper's `<div>` tag. */
  wrapperRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })])
};
var _default = exports.default = LayoutGrid;